export default "__VITE_ASSET__RJe_e7gQ__"